<!-- Filter Card (shown only when showFilters = true) -->
<div *ngIf="showFilters" class="container-fluid my-3">
  <div class="row g-3 bg-light rounded shadow-sm p-3 align-items-center">
    <!-- Clinic -->
    <div class="col-md-2">
      <label
        for="clinic"
        class="form-label fw-semibold text-secondary small mb-1"
        >Clinic</label
      >
      <p-dropdown
        id="clinic"
        name="clinic"
        [options]="clinicList"
        [(ngModel)]="clinic_id"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Clinic"
        styleClass="w-100"
      >
      </p-dropdown>
    </div>

    <!-- Doctor -->
    <div class="col-md-2">
      <label
        for="doctor"
        class="form-label fw-semibold text-secondary small mb-1"
        >Doctor</label
      >
      <p-dropdown
        id="doctor"
        name="doctor"
        [options]="doctorsList"
        [(ngModel)]="doctor_id"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Doctor"
        styleClass="w-100"
      >
      </p-dropdown>
    </div>

    <!-- Apply button -->
    <div class="col-md-2 text-end">
      <button
        class="btn btn-light border fw-semibold d-flex align-items-center gap-2 px-3 py-2"
        (click)="applyContext()"
      >
        <i class="pi pi-check-circle text-primary"></i>
        <span class="text-primary small">Apply Context</span>
      </button>
    </div>
  </div>
</div>

<div class="container-fluid mt-3">
  <div class="row" style="height: 100%; overflow: hidden">
    <p-sidebar
      [(visible)]="isPatientVisible"
      position="left"
      [modal]="true"
      [blockScroll]="true"
      dismissible="true"
      data-hotkey="patient-search"
      styleClass="queue-sidebar"
      [style]="{ width: '30vw' }"
    >
      <!-- <div class="col-md-2 border-end p-0 d-flex flex-column"> -->
      <div class="p-2 border-bottom">
        <h6 class="mb-1 fw-bold">Consultation</h6>
      </div>

      <!-- Tabs for Queue and Search -->
      <div class="medicine-sidebar-content p-1 w-100">
        <!-- <p-tabView [(activeIndex)]="pationtIndex" [style]="{width: '100% !important'}"> -->
        <!-- Queue Tab -->
        <!-- <p-tabPanel header="Queue"> -->
        <div class="queue-seg-group">
          <div class="queue-seg-label">Flow</div>
          <div class="queue-seg-tabs flow-tabs">
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueTypeFilter === 'all'"
              (click)="setQueueTypeFilter('all')"
            >
              All ({{ queue.length }})
            </button>
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueTypeFilter === 'new'"
              (click)="setQueueTypeFilter('new')"
            >
              New ({{ queueNewCount }})
            </button>
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueTypeFilter === 'follow_up'"
              (click)="setQueueTypeFilter('follow_up')"
            >
              Follow Up ({{ queueFollowUpCount }})
            </button>
          </div>
        </div>

        <div class="queue-seg-group">
          <div class="queue-seg-label">Mode</div>
          <div class="queue-seg-tabs mode-tabs">
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueModeFilter === 'all'"
              (click)="setQueueModeFilter('all')"
            >
              All ({{ queue.length }})
            </button>
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueModeFilter === 'OPD'"
              (click)="setQueueModeFilter('OPD')"
            >
              OPD ({{ queueOpdCount }})
            </button>
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueModeFilter === 'COURIER'"
              (click)="setQueueModeFilter('COURIER')"
            >
              Courier ({{ queueCourierCount }})
            </button>
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueModeFilter === 'NRI'"
              (click)="setQueueModeFilter('NRI')"
            >
              NRI ({{ queueNriCount }})
            </button>
            <button
              type="button"
              class="queue-seg-btn"
              [class.active]="queueModeFilter === 'MC'"
              (click)="setQueueModeFilter('MC')"
            >
              MC ({{ queueMedicineCollectionCount }})
            </button>
          </div>
        </div>

        <div class="medicine-queue-scroll">
          <div class="modern-queue-list">
            <button
              *ngFor="let item of filteredQueue; let i = index"
              class="list-group-item list-group-item-action modern-queue-card"
              [ngClass]="[
                getModernStatusColorClass(item),
                isNextPatient(item) ? 'next-patient-row' : '',
              ]"
            >
              <div
                class="card-left-border"
                [ngClass]="getModernStatusColorClass(item)"
              ></div>

              <div class="card-content">
                <div class="card-row-1">
                  <span class="queue-number">#{{ i + 1 }}</span>
                  <span class="patient-name">{{ item.name | uppercase }}</span>
                  <span
                    *ngIf="isNextPatient(item)"
                    class="next-chip ms-auto"
                    title="Next patient in queue"
                    >NEXT</span
                  >
                </div>

                <div class="card-row-2 text-muted">
                  <span class="visit-type">{{
                    getAppointmentTypeLabel(item.appointment_type)
                  }}</span>
                  <span *ngIf="item.gender" class="dot-separator">•</span>
                  <span *ngIf="item.gender" class="metadata-label">
                    {{ item.gender | titlecase }}
                    <ng-container *ngIf="item.age"
                      >{{ item.age }}y</ng-container
                    >
                  </span>
                  <span class="dot-separator">•</span>
                  <span
                    class="wait-time"
                    [ngClass]="
                      getWaitTimeColorClass(getWaitTimeLabel(item.raw_time))
                    "
                  >
                    {{ getWaitTimeLabel(item.raw_time) }}
                  </span>
                </div>

                <div class="card-row-3 text-muted mt-1">
                  <span
                    class="draft-indicator"
                    [pTooltip]="
                      item.status === 'assistant_doctor_done'
                        ? 'Assistant Draft Saved'
                        : 'No Draft Yet'
                    "
                    tooltipPosition="top"
                  >
                    <i
                      class="pi"
                      [ngClass]="
                        item.status === 'assistant_doctor_done'
                          ? 'pi-check-circle text-success'
                          : 'pi-circle text-400'
                      "
                      style="font-size: 12px"
                    ></i>
                  </span>
                  <span
                    class="lifecycle-label text-xs fw-semibold ms-1"
                    [ngStyle]="{
                      color:
                        item.status === 'assistant_doctor_done'
                          ? '#10b981'
                          : 'inherit',
                    }"
                  >
                    {{ getQueueLifecycleLabel(item) }}
                  </span>
                  <span class="dot-separator ms-2">•</span>
                  <span class="appt-time">
                    <i class="pi pi-clock me-1" style="font-size: 10px"></i
                    >{{ item.time }}
                  </span>
                  <span class="dot-separator">•</span>
                  <span class="mode-label">
                    <i class="pi pi-tag me-1" style="font-size: 10px"></i
                    >{{ getModeTitle(item.is_courier) }}
                  </span>
                  <span
                    *ngIf="isMedicineCollectionItem(item)"
                    class="dot-separator"
                    >•</span
                  >
                  <span
                    *ngIf="isMedicineCollectionItem(item)"
                    class="mode-label text-warning"
                  >
                    <i class="pi pi-box me-1" style="font-size: 10px"></i>MC
                  </span>
                </div>
              </div>
            </button>
          </div>
        </div>
        <!-- </p-tabPanel> -->
        <!-- </p-tabView> -->
      </div>
      <!-- </div> -->
    </p-sidebar>

    <button
      pButton
      type="button"
      icon="pi pi-users"
      class="queue-open-fab"
      *ngIf="!isPatientVisible"
      (click)="openQueueSidebar()"
      pTooltip="Open Queue Sidebar"
      aria-label="Queue"
    ></button>

    <div class="col-md-12">
      <app-calendar></app-calendar>
    </div>

    <!-- <p-sidebar [(visible)]="isMedicineVisible" position="right" [modal]="true" dismissible="true"
      [style]="{width:'30vw'}">
      <div class="p-2 border-bottom">
          <h6 class="mb-1 fw-bold">Medicine Collection</h6>
        </div>

        <div class="flex-grow-1 overflow-auto p-1 w-100">
          <p-tabView>

            <p-tabPanel header="Queue">
              <p-scrollPanel [style]="{ width: '100%', height: '500px' }">
                <div class="list-group list-group-flush p-0 m-0">
                  <button *ngFor="let item of medicineQueue"
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                    [ngClass]="getColorClass(item.status)" (click)="showMedicineDialog(item)">

                    {{ item.name }}
                    <span *ngIf="item.status === 'scheduled'" class="courier-badge status-badge status-scheduled" title="Scheduled">S</span>
                    <span *ngIf="(item.status === 'assistant_doctor') || (item.status === 'assistant_doctor_done')" class="courier-badge status-badge status-assistant-doctor" title="Assistant Doctor">AD</span>
                    <span *ngIf="item.status === 'doctor'" class="courier-badge status-badge status-doctor" title="Doctor">D</span>
                    <span *ngIf="item.status === 'pharmacy'" class="courier-badge status-badge status-pharmacy" title="Pharmacy">P</span>
                    <span *ngIf="(item.status === 'reception') || (item.status === 'receptionist')" class="courier-badge status-badge status-reception" title="Reception">R</span>
                    <span
                      class="courier-badge mode-badge"
                      [ngClass]="getModeBadgeClass(item.is_courier)"
                      [title]="getModeTitle(item.is_courier)">
                      {{ getModeInitial(item.is_courier) }}
                    </span>
                    <span class="text-muted">{{ item.time }}</span>
                  </button>
                </div>
              </p-scrollPanel>
            </p-tabPanel>
          </p-tabView>
        </div>
    </p-sidebar> -->

    <p-sidebar
      [(visible)]="isMedicineVisible"
      position="right"
      [modal]="true"
      [blockScroll]="true"
      dismissible="true"
      data-hotkey="patient-search"
      styleClass="medicine-collection-sidebar"
      [style]="{ width: '35vw' }"
    >
      <div class="p-2 border-bottom">
        <h6 class="mb-1 fw-bold">Medicine Collection</h6>
      </div>

      <div class="medicine-sidebar-content flex-grow-1 p-1 w-100">
        <div class="medicine-seg-sticky">
          <div class="queue-seg-group">
            <div class="queue-seg-label">Flow</div>
            <div class="queue-seg-tabs flow-tabs">
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueTypeFilter === 'all'"
                (click)="setMedicineQueueTypeFilter('all')"
              >
                All ({{ medicineQueueCounts.all }})
              </button>
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueTypeFilter === 'normal'"
                (click)="setMedicineQueueTypeFilter('normal')"
              >
                Normal Flow ({{ medicineQueueCounts.normal }})
              </button>
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueTypeFilter === 'scheduled'"
                (click)="setMedicineQueueTypeFilter('scheduled')"
              >
                Scheduled Later ({{ medicineQueueCounts.scheduled }})
              </button>
            </div>
          </div>

          <div class="queue-seg-group">
            <div class="queue-seg-label">Mode</div>
            <div class="queue-seg-tabs mode-tabs">
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueModeFilter === 'all'"
                (click)="setMedicineQueueModeFilter('all')"
              >
                All ({{ medicineQueueCounts.all }})
              </button>
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueModeFilter === 'OPD'"
                (click)="setMedicineQueueModeFilter('OPD')"
              >
                OPD ({{ medicineQueueCounts.OPD }})
              </button>
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueModeFilter === 'COURIER'"
                (click)="setMedicineQueueModeFilter('COURIER')"
              >
                Courier ({{ medicineQueueCounts.COURIER }})
              </button>
              <button
                type="button"
                class="queue-seg-btn"
                [class.active]="medicineQueueModeFilter === 'NRI'"
                (click)="setMedicineQueueModeFilter('NRI')"
              >
                NRI ({{ medicineQueueCounts.NRI }})
              </button>
            </div>
          </div>
        </div>

        <div class="medicine-queue-scroll">
          <div class="modern-queue-list mt-2">
            <button
              *ngFor="let item of visibleMedicineQueue; let i = index"
              tabindex="0"
              class="list-group-item list-group-item-action modern-queue-card"
              [ngClass]="[
                getModernStatusColorClass(item),
                isMedicineNextPatient(i) ? 'next-patient-row' : '',
              ]"
              (click)="showMedicineDialog(item)"
            >
              <div
                class="card-left-border"
                [ngClass]="getModernStatusColorClass(item)"
              ></div>
              <div class="card-content">
                <div class="card-row-1">
                  <span class="queue-number">#{{ i + 1 }}</span>
                  <span class="patient-name">{{ item.name | uppercase }}</span>
                  <span
                    *ngIf="isMedicineNextPatient(i)"
                    class="next-chip ms-auto"
                    [ngClass]="getMedicineNextClass(item)"
                  >
                    {{ getMedicineNextLabel(item) }}
                  </span>
                </div>

                <div class="card-row-2 text-muted">
                  <ng-container
                    *ngIf="getAppointmentTypeLabel(item.appointment_type)"
                  >
                    <span class="visit-type">{{
                      getAppointmentTypeLabel(item.appointment_type)
                    }}</span>
                    <span
                      *ngIf="item.gender || getMedicineQueuePaymentLabel(item)"
                      class="dot-separator"
                      >•</span
                    >
                  </ng-container>
                  <span *ngIf="item.gender" class="metadata-label">
                    {{ item.gender | titlecase }}
                    <ng-container *ngIf="item.age"
                      >{{ item.age }}y</ng-container
                    >
                  </span>
                  <span
                    *ngIf="
                      (getAppointmentTypeLabel(item.appointment_type) ||
                        item.gender) &&
                      getMedicineQueuePaymentLabel(item)
                    "
                    class="dot-separator"
                    >•</span
                  >
                  <span
                    *ngIf="getMedicineQueuePaymentLabel(item)"
                    class="payment-badge"
                    [ngClass]="getMedicineQueuePaymentClass(item)"
                    [title]="getMedicineQueuePaymentLabel(item)"
                  >
                    {{ getMedicineQueuePaymentLabel(item) }}
                  </span>
                </div>

                <div class="card-row-3 text-muted mt-1">
                  <span class="lifecycle-label text-xs fw-semibold">
                    {{ getQueueLifecycleLabel(item) }}
                  </span>
                  <span class="dot-separator ms-2">•</span>
                  <span class="appt-time">
                    <i class="pi pi-clock me-1" style="font-size: 10px"></i
                    >{{ this.formatTime(item.time) }} {{ item.formatdate }}
                  </span>
                  <span class="dot-separator">•</span>
                  <span class="mode-label">
                    <i class="pi pi-tag me-1" style="font-size: 10px"></i
                    >{{ getModeTitle(item.is_courier) }}
                  </span>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </p-sidebar>

    <button
      pButton
      type="button"
      icon="pi pi-list"
      class="medicine-open-fab"
      *ngIf="!isMedicineVisible"
      (click)="openMedicineQueueSidebar()"
      pTooltip="Open Medicine Queue Sidebar"
      aria-label="Medicine Queue"
    ></button>
  </div>
</div>

<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: 'min(64rem, calc(100vw - 1.25rem))' }"
  [showHeader]="false"
  styleClass="dispense-dialog paydesk-dialog"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
>
  <div class="paydesk" *ngIf="visible">
    <aside class="paydesk-rail">
      <div class="paydesk-rail__top">
        <div class="paydesk-avatar" aria-hidden="true">{{ patientInitials(selectedPatient?.name) }}</div>
        <div class="paydesk-identity">
          <p class="paydesk-kicker">Collect payment</p>
          <h2 class="paydesk-name">{{ selectedPatient?.name || 'Patient' }}</h2>
          <div class="paydesk-chips">
            <span *ngIf="selectedPatient?.date"><i class="pi pi-calendar"></i>{{ selectedPatient.date }}</span>
            <span *ngIf="selectedPatient?.time"><i class="pi pi-clock"></i>{{ selectedPatient.time }}</span>
          </div>
        </div>
      </div>

      <div class="paydesk-due" [class.is-clear]="!(selectedPatient?.personal_dues > 0)">
        <span class="paydesk-due__label">{{ selectedPatient?.personal_dues > 0 ? 'Remaining due' : 'Fully paid' }}</span>
        <strong class="paydesk-due__value">{{ (selectedPatient?.personal_dues || 0) | currency:'INR':'symbol':'1.0-0' }}</strong>
        <span class="paydesk-due__plan">{{ paymentPlanLabel }}</span>
      </div>

      <dl class="paydesk-ledger">
        <div>
          <dt>Visit fees</dt>
          <dd>{{ (selectedPatient?.visit_fees || 0) | currency:'INR':'symbol':'1.0-0' }}</dd>
        </div>
        <div class="paydesk-rx-ledger" *ngIf="paymentRxLines.length">
          <dt>Rx charges</dt>
          <dd>
            <ul>
              <li *ngFor="let line of paymentRxLines; let i = index">
                <span class="paydesk-rx-ledger__name">
                  {{ paymentRxTitle(line, i) }}
                  <em *ngIf="line.duration">{{ line.duration }}</em>
                </span>
                <strong>{{ (line.price || 0) | currency:'INR':'symbol':'1.0-0' }}</strong>
              </li>
            </ul>
          </dd>
        </div>
        <div>
          <dt>Received now</dt>
          <dd class="is-paid">{{ paymentReceivedTotal | currency:'INR':'symbol':'1.0-0' }}</dd>
        </div>
        <div *ngIf="priorCarryForward !== 0">
          <dt>Prior balance</dt>
          <dd [class.is-due]="priorCarryForward > 0">{{ priorCarryForward | currency:'INR':'symbol':'1.0-0' }}</dd>
        </div>
        <div *ngIf="selectedPatient?.history?.[0]?.follow_up_date">
          <dt>Follow-up</dt>
          <dd>{{ selectedPatient.history[0].follow_up_date }}</dd>
        </div>
      </dl>

      <div class="paydesk-note" *ngIf="selectedPatient?.special_instructions?.trim()">
        <span>Note</span>
        <p>{{ selectedPatient.special_instructions }}</p>
      </div>
    </aside>

    <section class="paydesk-main">
      <button type="button" class="paydesk-close" (click)="visible = false" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>

      <div class="paydesk-main__scroll">
      <div class="paydesk-step paydesk-step--plan">
        <div class="paydesk-step__head">
          <span class="paydesk-step__num">1</span>
          <h3>Consultation plan</h3>
        </div>

        <div class="paydesk-plans" role="radiogroup" aria-label="Consultation plan">
          <button
            type="button"
            class="paydesk-plan"
            role="radio"
            [attr.aria-checked]="paymentDurationMode === 'half'"
            [class.is-on]="paymentDurationMode === 'half'"
            (click)="setPaymentDurationMode('half')"
          >
            <span class="paydesk-plan__tag">Half</span>
            <span class="paydesk-plan__name">15 days</span>
            <span class="paydesk-plan__amt">{{ (paymentBaseVisitFee / 2) | currency:'INR':'symbol':'1.0-0' }}</span>
          </button>

          <button
            type="button"
            class="paydesk-plan"
            role="radio"
            [attr.aria-checked]="paymentDurationMode === 'monthly' && paymentMonthCount === 1"
            [class.is-on]="paymentDurationMode === 'monthly' && paymentMonthCount === 1"
            (click)="setPaymentMonthCount(1)"
          >
            <span class="paydesk-plan__tag">Standard</span>
            <span class="paydesk-plan__name">1 month</span>
            <span class="paydesk-plan__amt">{{ paymentBaseVisitFee | currency:'INR':'symbol':'1.0-0' }}</span>
          </button>

          <div
            class="paydesk-plan paydesk-plan--multi"
            role="radio"
            [attr.aria-checked]="paymentDurationMode === 'monthly' && paymentMonthCount > 1"
            [class.is-on]="paymentDurationMode === 'monthly' && paymentMonthCount > 1"
            (click)="setPaymentMonthCount(paymentMonthCount > 1 ? paymentMonthCount : 2)"
          >
            <span class="paydesk-plan__tag">Extended</span>
            <div class="paydesk-stepper">
              <button type="button" (click)="bumpPaymentMonths(-1, $event)" aria-label="Fewer months">−</button>
              <span class="paydesk-plan__name">{{ paymentMonthCount }} {{ paymentMonthCount === 1 ? 'month' : 'months' }}</span>
              <button type="button" (click)="bumpPaymentMonths(1, $event)" aria-label="More months">+</button>
            </div>
            <span class="paydesk-plan__amt">{{ (paymentBaseVisitFee * paymentMonthCount) | currency:'INR':'symbol':'1.0-0' }}</span>
          </div>

          <div class="paydesk-base">
            <label for="payment_base_fee">Base monthly fee</label>
            <div class="paydesk-money">
              <span>₹</span>
              <input
                id="payment_base_fee"
                type="number"
                min="0"
                [(ngModel)]="paymentBaseVisitFee"
                (ngModelChange)="applyPaymentPlan()"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="paydesk-split" [class.has-rx]="paymentRxLines.length > 0">
      <div class="paydesk-step" *ngIf="paymentRxLines.length">
        <div class="paydesk-step__head">
          <span class="paydesk-step__num">2</span>
          <h3>Rx charges</h3>
          <strong class="paydesk-step__total">{{ paymentRxTotal | currency:'INR':'symbol':'1.0-0' }}</strong>
        </div>

        <div class="paydesk-rx-table" role="table" aria-label="Prescription charges">
          <div class="paydesk-rx-table__head" role="row">
            <span role="columnheader">#</span>
            <span role="columnheader">Prescription</span>
            <span role="columnheader">Duration</span>
            <span role="columnheader">Price</span>
          </div>
          <div
            class="paydesk-rx-table__row"
            role="row"
            *ngFor="let line of paymentRxLines; let i = index"
          >
            <span class="paydesk-rx-table__idx" role="cell">{{ i + 1 }}</span>
            <span
              class="paydesk-rx-table__title"
              role="cell"
              [title]="paymentRxTitle(line, i)"
            >{{ paymentRxTitle(line, i) }}</span>
            <span class="paydesk-rx-table__duration" role="cell">{{ line.duration || '—' }}</span>
            <div class="paydesk-field paydesk-rx-price" role="cell">
              <label class="paydesk-sr-only" [for]="'rx_price_' + i">Price for {{ paymentRxTitle(line, i) }}</label>
              <div class="paydesk-money">
                <span>₹</span>
                <input
                  [id]="'rx_price_' + i"
                  type="number"
                  min="0"
                  [(ngModel)]="line.price"
                  (ngModelChange)="onPaymentRxPriceChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="paydesk-step">
        <div class="paydesk-step__head">
          <span class="paydesk-step__num">{{ paymentRxLines.length ? 3 : 2 }}</span>
          <h3>Collect now</h3>
        </div>

        <div class="paydesk-collect">
          <div class="paydesk-field">
            <label for="received_cash">Cash</label>
            <div class="paydesk-money">
              <span>₹</span>
              <input
                id="received_cash"
                type="number"
                min="0"
                [(ngModel)]="selectedPatient.received_cash"
                (ngModelChange)="updatePersonalDues()"
              />
            </div>
          </div>

          <div class="paydesk-field">
            <label for="received_online">Online / UPI</label>
            <div class="paydesk-money">
              <span>₹</span>
              <input
                id="received_online"
                type="number"
                min="0"
                [(ngModel)]="selectedPatient.received_online"
                (ngModelChange)="updatePersonalDues()"
              />
            </div>
          </div>

          <div class="paydesk-field" *ngIf="!paymentRxLines.length">
            <label for="visit_fees">Visit fees</label>
            <div class="paydesk-money">
              <span>₹</span>
              <input
                id="visit_fees"
                type="number"
                min="0"
                [(ngModel)]="selectedPatient.visit_fees"
                (ngModelChange)="syncPaymentBaseFee()"
              />
            </div>
          </div>
        </div>

        <div class="paydesk-quick">
          <button type="button" class="paydesk-chip" (click)="fillFullPayment('cash')">All cash</button>
          <button type="button" class="paydesk-chip" (click)="fillFullPayment('online')">All online</button>
          <button type="button" class="paydesk-chip" (click)="fillFullPayment('split')">Half / half</button>
          <button type="button" class="paydesk-chip paydesk-chip--muted" (click)="clearCollectedPayment()">Clear</button>
        </div>
      </div>
      </div>
      </div>

      <div class="paydesk-actions">
        <button type="button" class="paydesk-btn paydesk-btn--ghost" (click)="visible = false">Cancel</button>
        <button
          type="button"
          class="paydesk-btn paydesk-btn--primary"
          (click)="changeStatus(selectedPatient, 'payment')"
        >
          <i class="pi pi-save"></i>
          Save payment
        </button>
        <button
          type="button"
          class="paydesk-btn paydesk-btn--success"
          (click)="confirmCompleteAppointment($event, selectedPatient)"
        >
          <i class="pi pi-check-circle"></i>
          Complete appointment
        </button>
      </div>
    </section>
  </div>
</p-dialog>

<p-confirmPopup key="templatePopup"></p-confirmPopup>
